import Footer from '../footer/Footer';
import Navbar from '../navbar/Navbar';
import FacilitiesLeftTab from './FacilitiesLeftTab';


const Parking = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <FacilitiesLeftTab />
                        </div>

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>Parking Facility
                                </h2>
                                <p>
                                    Our college provides a convenient and secure parking facility for faculty and students, ensuring a hassle-free experience on campus. The parking area is spacious, with ample space to accommodate vehicles. To ensure safety and organization, we have dedicated lanes for cars and two-wheelers, separate from each other. This thoughtful design allows for efficient parking and reduces congestion, making it easier for everyone to navigate the campus.
                                </p>
                                <h6 className='pt-4 pb-3'>Parking Facility Images
                                </h6>
                               
                                <div className='pt-4 row'>
                                    <div className='col-md-6 pb-3'>
                                        <img src="https://admin.swec.ac.in/assetsswec/img/facilities/Parking.png" loading='lazy' className='img-fluid' alt='parking' />
                                    </div>
                                  

                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Parking
